import React from 'react'
import PropTypes from 'prop-types'
import { Row, Form, Checkbox } from 'antd'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

// Components
import EditableTable from "../../Table/EditableTable";
import DataGrid from "../../DataGrid";
import Api_tnn from "../../../api/api.tnn";
import Message from "../../Messages";
import EditorNumberField from "../../DataGrid/EditorNumberField";
import EditorCheckbox from "../../DataGrid/EditorCheckbox";
import UnClickableCheckbox from "../../Common/Checkbox/UnClickableCheckBox";
import helper from '../../../helper/helper'
import { keyframes } from 'styled-components'

const columns = [
  {
    name: "STT",
    key: "stt",
    width: 50,
  },
  {
    name: "Quan trắc tự động",
    key: "qT_TuDong",
    editor: EditorCheckbox,
    width: 100,
    formatter: ({ value }) => <UnClickableCheckbox checked={value} />,
    // formatter: ({value}) => <Checkbox checked={value} disabled={true}/>,
  },
  {
    name: "Quan trắc định kỳ",
    key: "qT_DinhKy",
    editor: EditorCheckbox,
    width: 100,
    formatter: ({ value }) => <UnClickableCheckbox checked={value} />,
    // formatter: ({value}) => <Checkbox checked={value} disabled={true}/>,
  },
  {
    name: "Thông số",
    key: "tenThongSo",
    editable: true,
  },
  {
    name: "Đơn vị",
    key: "tenDonVi",
    width: 100,
  },

  {
    name: "Giá trị Cmax từ",
    key: "gioiHanMin",
    editable: true,
    width: 100,
    rowSpan: 1,
    editor: EditorNumberField
  },
  {
    name: "Giá trị Cmax đến",
    key: "gioiHanMax",
    editable: true,
    width: 100,
    rowSpan: 1,
    editor: EditorNumberField
  },
];

class TSNDNuocThai extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: []
    }
  }

  componentDidMount() {
    const { initialValue } = this.props;
    initialValue && this.setState({ dataSource: initialValue })
  }

  handleUpdateDataSource = (newData) => {
    this.setState({ dataSource: newData })
  };

  getDataSource = () => {
    return this.state.dataSource
  };

  get_GioiHanThongSo = () => {
    const { user, listCLNuocThai } = this.props;
    const idDM_QCVNs = listCLNuocThai && listCLNuocThai.map((item) => item.idQCApDung);
    const clnt_gioihants_jsons = this.getDataSource();
    if (!isEmpty(listCLNuocThai)) {
      new Api_tnn().postCLNT_GioiHanThongSo_Init({
        token: user.access_token,
        auto: listCLNuocThai[0].Cmax === 1 ? "yes" : "no",
        mdsd_id: listCLNuocThai[0].idMucDichSuDung,
        kq: listCLNuocThai[0].heSoKQ ? listCLNuocThai[0].heSoKQ : 0,
        kf: listCLNuocThai[0].heSoKF ? listCLNuocThai[0].heSoKF : 0,
        k: listCLNuocThai[0].heSoK ? listCLNuocThai[0].heSoK : 0,
        obj: {
          'idDM_QCVNs': idDM_QCVNs,
          'clnt_gioihants_jsons': clnt_gioihants_jsons
        }
      })
        .then(res => {
          this.setState({ dataSource: res })
        })
        .catch(err => Message.error(err.message))
    } else {
      this.setState({ dataSource: [] })
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.setState({ dataSource: this.props.initialValue })
    } else if (prevProps.listCLNuocThai !== this.props.listCLNuocThai) {
      this.get_GioiHanThongSo()
    }
  }

  render() {
    const { mode } = this.props;
    const { dataSource } = this.state;
    return (
      <Row>
        <DataGrid
          enableCellSelect={mode !== "presentation"}
          dataSource={helper.addSttToDataSource(dataSource)}
          columns={columns}
          updateDataSource={this.handleUpdateDataSource} />
      </Row>
    )
  }
}

TSNDNuocThai.propTypes = {
  initialValue: PropTypes.object,
  mode: PropTypes.string.isRequired,
  listCLNuocThai: PropTypes.array.isRequired,
  user: PropTypes.any.isRequired,
};

export default TSNDNuocThai
